
































































import { Component } from 'vue-property-decorator';

import StoreIcon from '@/components/icons/StoreSolid.vue';
import DiscountTagIcon from '@/components/icons/DiscountTagSolid.vue';
import StarIcon from '@/components/icons/StarSolid.vue';
import RewardsProgramIcon from '@/components/icons/RewardsProgramSolid.vue';
import WidgetSettingsIcon from '@/components/icons/WidgetSettingsSolid.vue';
import SuccessIcon from '@/components/icons/SuccessSolid.vue';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import GhostButton from '@/components/molecules/GhostButton/GhostButton.vue';
import APIService from '@/api';
import {
  BusinessOnboardingState,
  BusinessOnboardingYourDigitalCoinsForm
} from '@/models/business-onboarding';
import { setBusinessOnboardingDataOnLocalStorage } from '@/store/modules/businessOnboarding';
import {
  getOauthState,
  isExternalOauthSessionOnline,
  isOauthSession
} from '@/router/router-utils';
import eventBus from '@/utils/eventBus';
import BusinessOnboardingModel from '@/views/BusinessOnboarding/BusinessOnboardingModel.vue';
import { getSignUpUrlPrefix } from '@/views/Onboarding/helpers';
import CoinSetupService from '@/api/CoinSetupService';
import flagKeys from '../../../constants/flagKeys';

@Component({
  components: {
    GhostButton,
    FilledButton,
    StoreIcon,
    DiscountTagIcon,
    StarIcon,
    SuccessIcon,
    RewardsProgramIcon,
    WidgetSettingsIcon
  }
})
export default class Manager extends BusinessOnboardingModel {
  coinSetupService = new CoinSetupService();
  business: any = {};

  loading = false;

  get name() {
    if (!this.$store.getters['manager/getExtraInfo']) return 'Merchant';

    return this.$store.getters['manager/getExtraInfo'].fullname.split(' ')[0];
  }

  get isSuperAdmin() {
    return this.$store.getters['business/isRootView'];
  }

  get isOnlineSignup() {
    return isExternalOauthSessionOnline();
  }

  get stateBusinessOnboarding() {
    return this.$store.getters[
      'businessOnboarding/getBusinessOnboardingState'
    ] as BusinessOnboardingState;
  }

  get steps() {
    const arrSteps = [
      {
        slug: 'coin-customize',
        label: 'Customize coin',
        completed: true
      },
      {
        slug: 'business-details',
        label: 'Business details',
        completed: this.isOnlineSignup,
        description: '2 min',
        icon: 'StoreIcon'
      },
      {
        slug: 'business-category',
        label: 'Business category',
        completed: this.isOnlineSignup,
        description: '1 min',
        icon: 'DiscountTagIcon'
      }
    ];

    if (this.isOnlineSignup) {
      arrSteps.push({
        slug: 'rewards',
        label: `Loyalty Program`,
        completed: !this.$route.query.onlineMerchantRewardStep,
        description: '2 min',
        icon: 'RewardsProgramIcon'
      });
      arrSteps.push({
        slug: 'loyalty-widget',
        label: 'Widget Settings',
        completed: false,
        description: '1 min',
        icon: 'WidgetSettingsIcon'
      });
    }

    return arrSteps;
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get externalSession() {
    return isExternalOauthSessionOnline();
  }

  async goNext() {
    if (this.externalSession && !this.business.id && isOauthSession()) {
      try {
        this.loading = true;
        const oauthState = getOauthState();

        await this.onCreateBusiness();
        this.business = this.$store.getters[
          'business/getBusinessInfo'
        ].business;

        this.onEditedImportedBusinessDate(oauthState);
      } finally {
        this.loading = false;
      }
    }
    const nextRoute = (() => {
      const businessOnboardingPrefix = getSignUpUrlPrefix();

      if (!this.isOnlineSignup || !this.business.id) {
        if (this.flags.includes(flagKeys.physicalBusinessOnboardingQ12026)) {
          return `${businessOnboardingPrefix}/your-digital-coin`;
        }

        return `${businessOnboardingPrefix}/your-store`;
      }

      if (!this.$route.query.onlineMerchantRewardStep)
        return `${businessOnboardingPrefix}/loyalty-widget`;

      return `${businessOnboardingPrefix}/reward-ratio`;
    })();

    this.$router.push(nextRoute);
  }

  logout() {
    APIService.resetCredentials();
  }

  setFormDataOnStore(formData: BusinessOnboardingYourDigitalCoinsForm) {
    const newBusinessStoreState: BusinessOnboardingState = {
      ...this.stateBusinessOnboarding,
      yourDigitalCoin: {
        form: formData
      }
    };
    this.$store.dispatch(
      'businessOnboarding/SET_YOUR_DIGITAL_COIN_FORM',
      formData
    );
    setBusinessOnboardingDataOnLocalStorage(newBusinessStoreState);
  }

  loadYourDigitalCoinData = async () => {
    const { status, data } = await this.coinSetupService.getCoin();

    if (status !== 200) return;

    const haveCoin2D = data.logo2d && data.logo2d.publicPath;

    if (haveCoin2D) {
      const yourDigitalCoinDataForm = {
        color: `#${data.color}`,
        colorKey: `${data.colorLabel}`,
        coinName: data.name.replace('$', ''),
        image: {
          imageUrl: data.logo2d.publicPath.original,
          imageName: `${data.name}_logo`
        },
        coinShowFront: true,
        isLoadingImg: false,
        coinFrontImgUrlSaved: data.coinFront2d.publicPath.original
      };

      this.setFormDataOnStore(yourDigitalCoinDataForm);
    }
  };

  mounted() {
    this.loadYourDigitalCoinData();
    if (this.isOnlineSignup) {
      this.businessService.getBusinessInfo().then((res: any) => {
        if (res && res.data) {
          eventBus.$emit('setBusinessInfo', res.data);
          const data = res.data;
          data.manager = data.loggedInManager;
          this.business = data;
          this.$store.dispatch('business/SET_BUSINESS_INFO', {
            ...this.$store.getters['business/getBusinessState'],
            ...data
          });
        }
      });
    }
  }
}
